import "../scss/_variables.scss";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { aliases, fa } from 'vuetify/iconsets/fa';

const seFosteringContactForm = {
    dark: false,
    colors: {
        primary: "#B02D6B",
        primaryHighlight: "#0A4D68",
        pink: "#B02D6B",
        header: "#AB1A54",
        text: "#323339",
        seHeaderTitle: "#0F152E",
        footer: "#0F152E",
        headerBannerBackgroundPrimary: "#F0F2F6FF",
        headerBannerBackgroundTertiary: "#FBF19DFF",
        mainNavy: '#30B4E5',
        seLink: '#fbf19d',
        seLinkHoverVisited: '#e3db92',
        seLinkBg: '#ab1a54',
        seLinkHoverVisitedBg: '#99184a',

        border: "#E4E4E4",
        backgroundBlue: "#E3F3F5",
        backgroundGrey: "#E3E3E3",
        cadet: "#5BA0AC",
        darkGrey: "#363A3D",
        lightGrey: "#696C6E",
        background: "#ffffff",
        secondary: "#256A67",
        secondaryshade: "#43908C",
        accent: "#82B1FF",
        error: "#B00020",
        info: "#2196F3",
        success: "#0F5132",
        active: "#61B865",
        inactive: "#B00121",
        warning: "#fc8d05",
        warningHighlight: "#fff4e4",
        white: "#FFFFFF",
        apprenticeship: '#694523',
        certificateOfCompetence: '#4E6CC1',
        engineroom: '#DB2391',
        fireHealthAndSafety: '#ED0A0A',
        foodSafety: '#864BD1',
        introductionToCommercialFishing: '#143F80',
        medical: '#006F87',
        navigationAndRadio: '#837810',
        nvq: '#B3611D',
        seaSafety: '#4B7E0B',
        svq: '#138942',
        southWestFosterHubEvents: '#0C24FF',
        statusFirstContactReceived: '#30276A',
        statusKeepWarm: '#616A9B',
        statusInitialEnquiryArranged: '#5D4226',
        statusInitialEnquiryOngoing: '#5D4226',
        statusSentToLA: '#2C5DA6',
        statusInitialEnquiryCompleted: '#B94300',
        statusAtLAAccepted: '#005337',
        statusAtLARejected: '#7E2B2F',
        statusAtLANATBC: '#6A7980',
        enquiryProgress: '#124D68',
        enquiryProgressDot: '#5A9FAB',
        btnHover: '#e7eef0',
        extra2: '#B000B4',
        extra3: '#873100',
        extra4: '#870000',
        extra5: '#008A1E',
        extra6: '#363A3D',
        extra7: '#143409',
        extra8: '#767676',
        extra9: '#0A0A0A',
    },
    variables: {
        'medium-emphasis-opacity': 1,
    },
};

const swFosteringContactForm = {
    dark: false,
    colors: {
        primary: "#0F3096",
        primaryHighlight: "#0A4D68",
        pink: "#0F3096",
        header: "#121E44",
        footer: "#121E44",
        text: "#121E44",
        headerBannerBackgroundPrimary: "#F0F2F6FF",
        headerBannerBackgroundTertiary: "#F9AD8F",
        swLink: '#0F3096',
        swLinkHoverVisited: '#F9AD8F',
        seLink: '#fbf19d',
        seLinkHoverVisited: '#e3db92',
        seLinkBg: '#ab1a54',
        seLinkHoverVisitedBg: '#99184a',

        border: "#E4E4E4",
        backgroundBlue: "#E3F3F5",
        backgroundGrey: "#E3E3E3",
        cadet: "#5BA0AC",
        darkGrey: "#363A3D",
        lightGrey: "#696C6E",
        background: "#ffffff",
        secondary: "#256A67",
        secondaryshade: "#43908C",
        accent: "#82B1FF",
        error: "#B00020",
        info: "#2196F3",
        success: "#0F5132",
        active: "#61B865",
        inactive: "#B00121",
        warning: "#fc8d05",
        warningHighlight: "#fff4e4",
        white: "#FFFFFF",
        apprenticeship: '#694523',
        certificateOfCompetence: '#4E6CC1',
        engineroom: '#DB2391',
        fireHealthAndSafety: '#ED0A0A',
        foodSafety: '#864BD1',
        introductionToCommercialFishing: '#143F80',
        medical: '#006F87',
        navigationAndRadio: '#837810',
        nvq: '#B3611D',
        seaSafety: '#4B7E0B',
        svq: '#138942',
        southWestFosterHubEvents: '#0C24FF',
        statusFirstContactReceived: '#30276A',
        statusKeepWarm: '#616A9B',
        statusInitialEnquiryArranged: '#5D4226',
        statusInitialEnquiryOngoing: '#5D4226',
        statusSentToLA: '#2C5DA6',
        statusInitialEnquiryCompleted: '#B94300',
        statusAtLAAccepted: '#005337',
        statusAtLARejected: '#7E2B2F',
        statusAtLANATBC: '#6A7980',
        enquiryProgress: '#124D68',
        enquiryProgressDot: '#5A9FAB',
        btnHover: '#e7eef0',
        extra2: '#B000B4',
        extra3: '#873100',
        extra4: '#870000',
        extra5: '#008A1E',
        extra6: '#363A3D',
        extra7: '#143409',
        extra8: '#767676',
        extra9: '#0A0A0A',
    },
    variables: {
        'medium-emphasis-opacity': 1,
    },
};

const activeTheme= (import.meta.env.VITE_FRONT_END_THEME === 'SE') ? seFosteringContactForm : swFosteringContactForm;

const vuetify= createVuetify({
    components,
    directives,
    defaults: {
        VCheckbox: {
            color: "primaryHighlight",
            "hideDetails" : 'auto',
        },
        VBtn: {
            color: "primary",
            rounded: "pill",
            style: [ {
                textTransform: 'none'
            }
            ],
        },
        VTextField: {
            "hideDetails" : 'auto',
        },
        VRadioGroup: {
            "hideDetails" : 'auto',
            "color" : 'primaryHighlight',
        },
        VTab: {
            "color": 'text'
        },
        VTextarea: {
            "hideDetails": 'auto',
        },
        VSelect: {
            "hideDetails": 'auto',
        },
        VCard: {
            'background': 'white',
        },
    },
    icons: {
        defaultSet: 'fa',
        aliases,
        sets: {
            fa,
        },
    },
    theme: {
        defaultTheme: "activeTheme",
        themes: {
            activeTheme,
        },
    },
});

export default vuetify;
